import React, { Component }  from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import insurance_icon from '../assets/images/insurance-icon.png';

import '../assets/styles/InsuranceRow.scss';

export class InsuranceRow extends Component {

    constructor(props) {
        super(props);
    }

    getInsuranceName(id){
      var insurance = this.props.insurances.find(obj => obj.id === id);
      if(insurance){
        return insurance.name;
      }else{
        return '-';
      }
  }
  
  showTooltipInsurances(ids){
      return <Tooltip id="insurance-tooltip">
          {ids.map((id, index) => {
          if(index < 2) return;
          return <div key={`tooltip-insurance-${index}`}>{this.getInsuranceName(id)}</div>;
          }) }
      </Tooltip>;
  }

    render() {
      if (this.props.insurance_ids.length > 0) {
        return (
          <div className="insurance-container">
            <div className="icon-col">
                <img className="insurance-icon" src={insurance_icon} alt='insurance-icon' />
            </div>
            <div className="insurance-col">
                {
                this.props.insurance_ids.map((insurance_id, index) => {
                    if(index > 2) return;
                    return <div key={`insurance-${index}`} className="insurance-tag">{index < 2 ? this.getInsuranceName(insurance_id) : <OverlayTrigger placement="bottom" overlay={this.showTooltipInsurances(this.props.insurance_ids)}>
                    <span>+{this.props.insurance_ids.length - 2} more</span>
                </OverlayTrigger>}</div>
                })
                }
            </div>
          </div>
        )
      } else {
        return null;
      }
  }
}